/* Eigener Filter fuer grosse Kategorien (ueber 5.000 Artikel, dort berechnet Shopify keine Filter).
   Daten: Indexdatei je Oberkategorie (assets/mb-fi-*.txt, gebaut von ueb/fidx/bauen.js):
     Zeile 1 "V" + Fabrikate, Zeile 2 "T" + Typen, danach handle, Fabrikat-Nr., Typ-Nr., d, D, B.
   Gefiltert wird im Browser; die Trefferzeilen laedt der Abschnitt main-search-liste ueber
   /search?q=mbh:h1 h2 ... (20 je Seite, Preise und Vorrat immer aktuell).
   Zustand steht in der Adresse: mbi/mba/mbb = Innen/Aussen/Breite "von-bis", mbh = Fabrikate,
   mbt = Typen (je mit | getrennt), mbs = Seite. */
(function () {
  var form = document.querySelector('form.mbg');
  if (!form) return;
  var haupt = document.querySelector('.mb-haupt');
  var tbody = haupt && haupt.querySelector('.mb-liste tbody');
  var anzahlEl = document.querySelector('.mb-top span');
  if (!tbody) return;
  var PRO_SEITE = 20;
  var erlaubteTypen = (form.dataset.typen || '').split('|').filter(Boolean).map(function (t) { return t.toLowerCase(); });
  var original = { tbody: tbody.innerHTML, anzahl: anzahlEl ? anzahlEl.textContent : '', seiten: null };
  var pagerAlt = haupt.querySelector('.mb-seiten');
  if (pagerAlt) original.seiten = pagerAlt.outerHTML;
  var basis = [], V = [], T = [], vKey = [], vLabel = {};
  var zahl = function (s) { var n = parseFloat(String(s).replace(',', '.')); return isNaN(n) ? NaN : n; };

  // ---------- Zustand aus der Adresse ----------
  function lesen() {
    var p = new URLSearchParams(location.search);
    var bereich = function (k) { var w = (p.get(k) || '').split('-'); return [zahl(w[0]), zahl(w[1])]; };
    return {
      i: bereich('mbi'), a: bereich('mba'), b: bereich('mbb'),
      h: (p.get('mbh') || '').split('|').filter(Boolean),
      t: (p.get('mbt') || '').split('|').filter(Boolean),
      s: Math.max(1, parseInt(p.get('mbs') || '1', 10) || 1)
    };
  }
  function schreiben(st, neu) {
    var p = new URLSearchParams(location.search);
    ['mbi', 'mba', 'mbb', 'mbh', 'mbt', 'mbs', 'page'].forEach(function (k) { p.delete(k); });
    var b = function (k, r) { if (!isNaN(r[0]) || !isNaN(r[1])) p.set(k, (isNaN(r[0]) ? '' : r[0]) + '-' + (isNaN(r[1]) ? '' : r[1])); };
    b('mbi', st.i); b('mba', st.a); b('mbb', st.b);
    if (st.h.length) p.set('mbh', st.h.join('|'));
    if (st.t.length) p.set('mbt', st.t.join('|'));
    if (st.s > 1) p.set('mbs', st.s);
    var url = location.pathname + (p.toString() ? '?' + p.toString() : '');
    if (neu) history.pushState(null, '', url); else history.replaceState(null, '', url);
  }
  var aktiv = function (st) { return [st.i, st.a, st.b].some(function (r) { return !isNaN(r[0]) || !isNaN(r[1]); }) || st.h.length || st.t.length; };

  // ---------- Filtern ----------
  var imBereich = function (x, r) { if (isNaN(r[0]) && isNaN(r[1])) return true; if (isNaN(x)) return false; return (isNaN(r[0]) || x >= r[0]) && (isNaN(r[1]) || x <= r[1]); };
  function passt(z, st, ohne) {
    if (!imBereich(z.d, st.i) || !imBereich(z.D, st.a) || !imBereich(z.B, st.b)) return false;
    if (ohne !== 'h' && st.h.length && st.h.indexOf(vKey[z.v]) < 0) return false;
    if (ohne !== 't' && st.t.length && st.t.indexOf(T[z.t]) < 0) return false;
    return true;
  }

  // ---------- Leiste ----------
  function liste(ul, eintraege, gewaehlt) {
    ul.innerHTML = eintraege.map(function (e) {
      var an = gewaehlt.indexOf(e.k) >= 0;
      return '<li' + (e.n === 0 && !an ? ' class="mbf-leer"' : '') + '><label><input type="checkbox" value="' + e.k.replace(/"/g, '&quot;') + '"' + (an ? ' checked' : '') + (e.n === 0 && !an ? ' disabled' : '') + '><span class="mbf-text">' + e.l.replace(/</g, '&lt;') + '</span><span class="mbf-anzahl">' + e.n + '</span></label></li>';
    }).join('');
  }
  function leiste(st) {
    [['i', '.mbg-innen'], ['a', '.mbg-aussen'], ['b', '.mbg-breite']].forEach(function (x) {
      var g = form.querySelector(x[1]); if (!g) return;
      var r = st[x[0]];
      g.querySelector('.mbf-von').value = isNaN(r[0]) ? '' : r[0];
      g.querySelector('.mbf-bis').value = isNaN(r[1]) ? '' : r[1];
    });
    // Fabrikate mit Trefferzahl (ohne den eigenen Filter gezaehlt)
    var nh = {}, nt = {};
    basis.forEach(function (z) {
      if (passt(z, st, 'h')) nh[vKey[z.v]] = (nh[vKey[z.v]] || 0) + 1;
      if (passt(z, st, 't')) nt[T[z.t]] = (nt[T[z.t]] || 0) + 1;
    });
    var keys = Object.keys(vLabel).sort(function (x, y) { return vLabel[x].localeCompare(vLabel[y], 'de'); });
    liste(form.querySelector('.mbg-hersteller .mbf-werte'), keys.map(function (k) { return { k: k, l: vLabel[k], n: nh[k] || 0 }; }), st.h);
    var tg = form.querySelector('.mbg-typ');
    var typen = T.filter(function (t, i) { return basis.some(function (z) { return z.t === i; }); });
    tg.hidden = typen.length < 2;
    liste(tg.querySelector('.mbf-werte'), typen.map(function (t) { return { k: t, l: t, n: nt[t] || 0 }; }), st.t);
    // Platzhalter: kleinster und groesster Wert
    [['d', '.mbg-innen'], ['D', '.mbg-aussen'], ['B', '.mbg-breite']].forEach(function (x) {
      var min = Infinity, max = -Infinity;
      basis.forEach(function (z) { var w = z[x[0]]; if (!isNaN(w)) { if (w < min) min = w; if (w > max) max = w; } });
      var g = form.querySelector(x[1]);
      if (!g) return; // z. B. Gehaeuse ohne Massfilter
      if (min <= max) { g.querySelector('.mbf-von').placeholder = min; g.querySelector('.mbf-bis').placeholder = max; }
      // Regler (mb-regler.js) ueber die vorhandenen Werte
      if (window.mbRegler && !g.dataset.regler) {
        var w = {}; basis.forEach(function (z) { if (!isNaN(z[x[0]])) w[z[x[0]]] = 1; });
        window.mbRegler.init(g.querySelector('.mbf-preis'), Object.keys(w).map(Number).sort(function (p, q) { return p - q; }));
        g.dataset.regler = '1';
      } else if (window.mbRegler) {
        window.mbRegler.init(g.querySelector('.mbf-preis'), g.querySelector('.mbr') ? g.querySelector('.mbr').werte : []);
      }
    });
    form.querySelectorAll('.mbg-hersteller .mbf-zahl, .mbg-typ .mbf-zahl').forEach(function (e) { e.remove(); });
    [['.mbg-hersteller', st.h.length], ['.mbg-typ', st.t.length]].forEach(function (x) {
      if (x[1]) form.querySelector(x[0] + ' > summary').insertAdjacentHTML('beforeend', ' <span class="mbf-zahl">' + x[1] + '</span>');
    });
  }

  // ---------- Chips ----------
  function chips(st) {
    var box = haupt.querySelector('.mbf-aktiv');
    if (!box) { box = document.createElement('div'); box.className = 'mbf-aktiv'; haupt.insertBefore(box, haupt.firstChild); }
    var c = [];
    var bt = function (r) { return (isNaN(r[0]) ? '…' : r[0]) + (r[0] === r[1] ? '' : ' – ' + (isNaN(r[1]) ? '…' : r[1])) + ' mm'; };
    [['i', 'Innen'], ['a', 'Außen'], ['b', 'Breite']].forEach(function (x) { var r = st[x[0]]; if (!isNaN(r[0]) || !isNaN(r[1])) c.push(['b' + x[0], x[1] + ': ' + bt(r)]); });
    st.h.forEach(function (k) { c.push(['h' + k, 'Hersteller: ' + (vLabel[k] || k)]); });
    st.t.forEach(function (t) { c.push(['t' + t, t]); });
    box.hidden = !c.length;
    box.innerHTML = c.map(function (x) { return '<button type="button" class="mbf-chip" data-weg="' + x[0].replace(/"/g, '&quot;') + '">' + x[1].replace(/</g, '&lt;') + '<span aria-hidden="true">×</span></button>'; }).join('') + (c.length ? '<button type="button" class="mbf-alle" data-weg="*">Alle entfernen</button>' : '');
  }

  // ---------- Treffer laden ----------
  var lauf = 0;
  function seitenleiste(n, s) {
    var seiten = Math.ceil(n / PRO_SEITE);
    var alt = haupt.querySelector('.mb-seiten');
    if (seiten < 2) { if (alt) alt.remove(); return; }
    var knopf = function (p, txt, akt) { return akt ? '<span class="mb-seite mb-seite-aktiv">' + txt + '</span>' : '<a href="#" class="mb-seite" data-seite="' + p + '">' + txt + '</a>'; };
    var h = '<nav class="mb-seiten" aria-label="Seiten">';
    h += s > 1 ? '<a href="#" class="mb-pfeilbtn" data-seite="' + (s - 1) + '">‹</a>' : '<span class="mb-pfeilbtn mb-aus">‹</span>';
    var von = Math.max(1, s - 2), bis = Math.min(seiten, s + 2);
    if (von > 1) h += knopf(1, '1') + (von > 2 ? '<span class="mb-luecke">…</span>' : '');
    for (var p = von; p <= bis; p++) h += knopf(p, p, p === s);
    if (bis < seiten) h += (bis < seiten - 1 ? '<span class="mb-luecke">…</span>' : '') + knopf(seiten, seiten);
    h += s < seiten ? '<a href="#" class="mb-naechste" data-seite="' + (s + 1) + '">Weiter ›</a>' : '';
    h += '<span class="mb-seiten-von">' + ((s - 1) * PRO_SEITE + 1) + '–' + Math.min(n, s * PRO_SEITE) + ' von ' + n + '</span></nav>';
    if (alt) alt.outerHTML = h; else haupt.insertAdjacentHTML('beforeend', h);
  }
  function anzeigen(st) {
    chips(st);
    if (!aktiv(st)) {
      tbody.innerHTML = original.tbody;
      if (anzahlEl) anzahlEl.textContent = original.anzahl;
      var p = haupt.querySelector('.mb-seiten');
      if (original.seiten) { if (p) p.outerHTML = original.seiten; else haupt.insertAdjacentHTML('beforeend', original.seiten); } else if (p) p.remove();
      haupt.classList.remove('mbf-laedt');
      return;
    }
    var treffer = basis.filter(function (z) { return passt(z, st); });
    if (anzahlEl) anzahlEl.textContent = original.anzahl.replace(/[\d.]+/, treffer.length);
    var seiten = Math.max(1, Math.ceil(treffer.length / PRO_SEITE));
    if (st.s > seiten) st.s = seiten;
    seitenleiste(treffer.length, st.s);
    if (!treffer.length) { tbody.innerHTML = '<tr><td colspan="5" class="mb-leer" style="padding:2rem .8rem">Keine Artikel mit diesen Filtern.</td></tr>'; return; }
    var handles = treffer.slice((st.s - 1) * PRO_SEITE, st.s * PRO_SEITE).map(function (z) { return z.h; });
    var meine = ++lauf;
    haupt.classList.add('mbf-laedt');
    var p = new URLSearchParams(location.search);
    var url = '/search?type=product&section_id=main-search-liste&q=' + encodeURIComponent('mbh:' + handles.join(' ')) + (p.get('preview_theme_id') ? '&preview_theme_id=' + p.get('preview_theme_id') : '');
    fetch(url, { credentials: 'same-origin' }).then(function (r) { return r.text(); }).then(function (html) {
      if (meine !== lauf) return;
      var d = new DOMParser().parseFromString(html, 'text/html');
      var neu = d.querySelector('.mb-liste tbody');
      tbody.innerHTML = neu ? neu.innerHTML : '';
      haupt.classList.remove('mbf-laedt');
    }).catch(function () { haupt.classList.remove('mbf-laedt'); });
  }

  // ---------- Bedienung ----------
  function ausFormular() {
    var st = lesen();
    var r = function (sel) { var g = form.querySelector(sel); if (!g) return [NaN, NaN]; return [zahl(g.querySelector('.mbf-von').value), zahl(g.querySelector('.mbf-bis').value)]; };
    st.i = r('.mbg-innen'); st.a = r('.mbg-aussen'); st.b = r('.mbg-breite');
    st.h = [].map.call(form.querySelectorAll('.mbg-hersteller input:checked'), function (c) { return c.value; });
    st.t = [].map.call(form.querySelectorAll('.mbg-typ input:checked'), function (c) { return c.value; });
    st.s = 1;
    return st;
  }
  function neu(st, push) { schreiben(st, push); leiste(st); anzeigen(st); }
  form.addEventListener('submit', function (e) { e.preventDefault(); neu(ausFormular(), true); });
  form.addEventListener('change', function (e) { if (e.target.type === 'checkbox') neu(ausFormular(), true); });
  form.querySelectorAll('.mbf-suche').forEach(function (s) {
    s.addEventListener('input', function () {
      var q = s.value.trim().toLowerCase();
      s.nextElementSibling.querySelectorAll('li').forEach(function (x) { x.hidden = q && x.textContent.toLowerCase().indexOf(q) < 0; });
    });
  });
  haupt.addEventListener('click', function (e) {
    var a = e.target.closest('[data-seite]');
    if (a) { e.preventDefault(); var st = lesen(); st.s = +a.dataset.seite; schreiben(st, true); anzeigen(st); haupt.scrollIntoView({ behavior: 'smooth', block: 'start' }); return; }
    var w = e.target.closest('[data-weg]');
    if (!w) return;
    var st = lesen(), k = w.dataset.weg;
    if (k === '*') st = { i: [NaN, NaN], a: [NaN, NaN], b: [NaN, NaN], h: [], t: [], s: 1 };
    else if (k[0] === 'b') st[k[1]] = [NaN, NaN];
    else if (k[0] === 'h') st.h = st.h.filter(function (x) { return x !== k.slice(1); });
    else if (k[0] === 't') st.t = st.t.filter(function (x) { return x !== k.slice(1); });
    st.s = 1;
    neu(st, true);
  });
  window.addEventListener('popstate', function () { var st = lesen(); leiste(st); anzeigen(st); });

  // ---------- Start: Index laden ----------
  var st0 = lesen();
  if (aktiv(st0)) haupt.classList.add('mbf-laedt');
  fetch(form.dataset.index).then(function (r) { return r.text(); }).then(function (txt) {
    var zeilen = txt.split('\n');
    V = zeilen[0].split('\t').slice(1); T = zeilen[1].split('\t').slice(1);
    // Fabrikate ohne Gross-/Kleinschreibung zusammenfassen (Asahi = ASAHI), Anzeige in der haeufigsten Schreibweise
    var haeufig = {};
    for (var i = 2; i < zeilen.length; i++) {
      var f = zeilen[i].split('\t'); if (f.length < 3) continue;
      var t = +f[2];
      if (erlaubteTypen.length && erlaubteTypen.indexOf(T[t].toLowerCase()) < 0) continue;
      basis.push({ h: f[0], v: +f[1], t: t, d: zahl(f[3]), D: zahl(f[4]), B: zahl(f[5]) });
      haeufig[f[1]] = (haeufig[f[1]] || 0) + 1;
    }
    var best = {};
    V.forEach(function (v, i) {
      var k = v.toUpperCase(); vKey[i] = k;
      if (!best[k] || (haeufig[i] || 0) > (haeufig[best[k]] || 0)) best[k] = i;
    });
    Object.keys(best).forEach(function (k) { if (basis.some(function (z) { return vKey[z.v] === k; })) vLabel[k] = V[best[k]]; });
    form.classList.remove('mbg-wartet');
    leiste(st0);
    anzeigen(st0);
  }).catch(function () { haupt.classList.remove('mbf-laedt'); form.insertAdjacentHTML('beforeend', '<p class="mbf-hinweis">Filter konnte nicht geladen werden.</p>'); });
})();
